export default "__VITE_ASSET__BFgYtDbq__"